import { _dashboardUrls } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';

interface DashboardPayload {
  userId: string;
}

const dashboardApi = createAsyncThunk(
  'dashboardApi',
  async (payload: DashboardPayload, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const url = `${_dashboardUrls.get}`;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ loggedInUserId: payload.userId }),
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      return await response.json();
    } catch (error: any) {
      console.error('Error fetching data:', error);
      return rejectWithValue(error.message);
    }
  }
);

export default dashboardApi;
